import ValidationMessage from './ValidationMessage';

export default ValidationMessage;
